import { render, staticRenderFns } from "./ClientTickets.vue?vue&type=template&id=598e55df&scoped=true&"
import script from "./ClientTickets.vue?vue&type=script&lang=js&"
export * from "./ClientTickets.vue?vue&type=script&lang=js&"
import style0 from "./ClientTickets.vue?vue&type=style&index=0&id=598e55df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598e55df",
  null
  
)

export default component.exports